import { useEffect, useState } from "react";
import { Section, Kicker, Reveal } from "./primitives";

const getTarget = () => {
  const now = new Date();
  const t = new Date(now);
  t.setHours(18, 0, 0, 0);
  let diff = (6 - now.getDay() + 7) % 7;
  if (diff === 0 && now >= t) diff = 7;
  t.setDate(now.getDate() + diff);
  return t;
};

const pad = (n) => String(n).padStart(2, "0");

export const Urgencia = () => {
  const [left, setLeft] = useState(() => getTarget() - new Date());

  useEffect(() => {
    const id = setInterval(() => setLeft(Math.max(0, getTarget() - new Date())), 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    ["DÍAS", Math.floor(left / 86400000)],
    ["HORAS", Math.floor((left / 3600000) % 24)],
    ["MIN", Math.floor((left / 60000) % 60)],
    ["SEG", Math.floor((left / 1000) % 60)],
  ];

  const cells = [
    { k: "APERTURA DE INSCRIPCIONES", v: "Sábado · 9:00 AM", warn: false },
    { k: "CIERRE DE CARRITO INAMOVIBLE", v: "Sábado · 6:00 PM", warn: true },
    { k: "VENTANA DISPONIBLE", v: "Solo 9 horas", warn: false },
  ];

  return (
    <Section id="cierre" band>
      <Reveal>
        <Kicker num="08" label="Cierre definitivo" />
        <h2 className="max-w-3xl font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
          Atención: las puertas se cierran hoy
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div
          data-testid="countdown-timer"
          className="mt-12 grid grid-cols-4 gap-3 sm:gap-5"
        >
          {units.map(([label, val]) => (
            <div
              key={label}
              className="rounded-2xl border border-rose-400/25 bg-rose-400/[0.04] px-2 py-5 text-center sm:py-7"
            >
              <div className="font-tech text-3xl font-bold tabular-nums text-slate-50 sm:text-5xl">
                {pad(val)}
              </div>
              <div className="mt-2 font-tech text-[9px] tracking-[0.3em] text-rose-300/80 sm:text-[11px]">
                {label}
              </div>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-6 grid gap-4 sm:grid-cols-3">
          {cells.map((c) => (
            <div
              key={c.k}
              className={`rounded-2xl border p-5 ${
                c.warn
                  ? "border-amber-400/40 bg-amber-400/[0.06]"
                  : "border-white/10 bg-white/[0.02]"
              }`}
            >
              <span className={`font-tech text-[10px] tracking-[0.25em] ${c.warn ? "text-amber-300" : "text-slate-500"}`}>
                {c.k}
              </span>
              <div className={`mt-2 font-display text-lg font-bold sm:text-xl ${c.warn ? "text-amber-300" : "text-slate-100"}`}>
                {c.v}
              </div>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.2}>
        <p className="mt-8 max-w-3xl text-sm leading-relaxed text-slate-400 sm:text-base">
          Hora Colombia / Perú / México. Una vez que el reloj marque las 6:00 PM,
          cerraremos el acceso para enfocarnos exclusivamente en los alumnos inscritos y
          preparar las sesiones en vivo sobre los equipos. No habrá reaperturas a este
          precio.
        </p>
      </Reveal>
    </Section>
  );
};
